import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import updateParams from '../../../../../utils/updateParams';
import SharedButton from '../../../../../global/Button/Button';
import { SourceButtonGroupProps } from '../../../../../types';

const specialFilters = ['CURATED', 'CLINICALTRIALS', 'INFERRED', 'MODELS', 'TEXTMINING_HUMAN', 'ALL'];

function getCurrentSource(search: string): string | null {
  const params = new URLSearchParams(search);
  return params.get('source');
}

export default function SourceButtonGroup({
  sourceList,
  category,
  isScoreSource = true,
}: SourceButtonGroupProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const currentSource = getCurrentSource(location.search);

  const primarySources = sourceList.filter(value => value === category || specialFilters.includes(value));

  const [sliderValues, setSliderValues] = useState<Record<string, number>>({
    CURATED: 0.7,
    CLINICALTRIALS: 0.1,
    INFERRED: 0.25,
    MODELS: 0.1,
    TEXTMINING_HUMAN: 0.4,
    ALL: 1,
  });

  const handleClick = (value: string) => {
    navigate({
      pathname: location.pathname,
      search: updateParams({ source: value }),
    });
  };

  const handleSliderChange = (source: string, value: number) => {
    setSliderValues(prev => ({ ...prev, [source]: value }));
  };

  const filteredSourceList = !isScoreSource
    ? sourceList
    : sourceList.filter(value => value === category || specialFilters.includes(value));

  return (
    <div className="flex flex-wrap gap-4" id="SUBMENU">
      {filteredSourceList.map(value => {
        const isCategoryMain = category && value === category;
        const sliderValue = sliderValues[value] ?? 0;
        return (
          <div key={value} className="flex items-center gap-3">
            <SharedButton
              onClick={() => handleClick(value)}
              isActive={currentSource === value}
              size="sm"
              className="text-blue"
              variant={isCategoryMain || specialFilters.includes(value) ? 'primary' : 'secondary'}
            >
              {value.replace('_', ' ')}
            </SharedButton>

            {isScoreSource && primarySources && (
              <div className="flex items-center">
                <input
                  type="range"
                  min={0}
                  max={1}
                  step={0.01}
                  value={sliderValue}
                  onChange={e => handleSliderChange(value, parseFloat(e.target.value))}
                  className="w-28 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer score-slider"
                />
                <span className="text-xs text-gray-700 ml-2">{sliderValue.toFixed(2)}</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
